import { IconFooter, IconFooterItem } from 'cpfr-common';
import {
    IconFooter as IconFooterShared,
    IconFooterItem as IconFooterItemShared,
    useAnalyticsActionTracker,
} from '@cp-shared-19/frontend-ui';
import React from 'react';
import { useLocation } from 'react-router-dom';

export const IconFooterUi: React.FC<{ iconFooter?: IconFooter; isLoggedIn?: boolean }> = ({ iconFooter }) => {
    const { onAction } = useAnalyticsActionTracker('onClickEmailLink');
    const location = useLocation();
    const currentPageName = location.pathname.split('/')[1];

    if (!iconFooter || !iconFooter.items) {
        return null;
    }

    const items = iconFooter.items.map((item: IconFooterItem): IconFooterItemShared => {
        const isExternalLink = item.linkUrl?.startsWith('http') || false;
        return {
            ...item,
            normalLink: item.linkText === 'Foire aux questions',
            target: isExternalLink ? 'blank' : undefined,
            ...(isExternalLink ? { element: 'a' } : {}),
            ...(item.ariaLabel ? { 'aria-label': item.ariaLabel } : {}),
            modalContent: item.modalContent ? (
                <div dangerouslySetInnerHTML={{ __html: item.modalContent as string }} />
            ) : null,
        };
    });

    return (
        <IconFooterShared
            items={items}
            trackingFunction={onAction}
            currentPageName={currentPageName}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            headingLevel={false as any}
        />
    );
};
